import HeroBanner from '@/components/HeroBanner/HeroBanner';
import { getAnchorId, getComponentMargin } from '@/utils/builderUtils';

function imagesSet(mobileSrc, desktopSrc) {
  return [
    {
      src: mobileSrc || desktopSrc,
      size: { width: 499, aspectRatio: 768 / 640 },
      breakpoint: 499,
      quality: 100,
    },
    {
      src: mobileSrc || desktopSrc,
      size: { width: 1023, aspectRatio: 768 / 640 },
      breakpoint: 1023,
      quality: 100,
    },
    {
      src: desktopSrc,
      size: { width: 1440, aspectRatio: 1440 / 450 },
      breakpoint: 1024, // this breakpoint must be present
      quality: 100,
    },
    {
      src: desktopSrc,
      size: { width: 2880, aspectRatio: 1440 / 450 },
      breakpoint: 1440,
      quality: 100,
    },
  ];
}

export default function StandardHeroBannerBuilder({
  background,
  desktopVideoUri,
  mobileVideoUri,
  autoPlay,
  loop,
  controls,
  altImageText,
  title,
  description,
  actions,
  anchorLinkID,
  margin,
  copyColor,
  sectionLink,
  desktopCopyPosition,
  fileVideoSrc,
  fileMobileVideoSrc,
  isWistia,
  hasSound,
  mobileTitle,
}) {
  const backgroundProp = imagesSet(background?.mobile, background?.desktop);
  const backgroundMobileProp = [
    {
      src: background?.mobile,
      size: { width: 499, aspectRatio: 768 / 640 },
      breakpoint: 499,
      quality: 100,
    },
  ];
  const slicedActions = actions?.slice(0, 2).map(action => ({
    ...action,
    color: action.color === 'dark' ? 'dark-green' : 'white',
    mobileColor: action.mobileColor === 'dark' ? 'dark-green' : 'white',
  }));

  return (
    <div {...getAnchorId(anchorLinkID)}>
      <HeroBanner
        background={backgroundProp}
        backgroundMobile={backgroundMobileProp}
        autoPlay={autoPlay}
        controls={controls}
        loop={loop}
        title={title}
        description={description}
        actions={slicedActions}
        videoSrc={isWistia ? desktopVideoUri : null}
        mobileVideoSrc={isWistia ? mobileVideoUri : null}
        fileVideoSrc={fileVideoSrc}
        fileMobileVideoSrc={fileMobileVideoSrc}
        imgAlt={altImageText}
        sectionLink={sectionLink}
        className={getComponentMargin(margin)}
        type="standard"
        contentColor={copyColor === 'white' ? 'light' : 'dark'}
        contentHorizontalPosition="center"
        contentHorizontalPositionTablet="center"
        contentHorizontalPositionDesktop={desktopCopyPosition}
        contentVerticalPosition="bottom"
        contentVerticalPositionTablet="bottom"
        contentVerticalPositionDesktop="center"
        hasSound={hasSound}
        mobileTitle={mobileTitle}
      />
    </div>
  );
}
